import {
  GET_FILE_BY_AREA,
  GET_FILE_BY_AREA_SUCCESS,
  GET_FILE_BY_AREA_FAIL,
  UPLOAD_FILE,
  UPLOAD_FILE_FAIL,
  UPLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAIL,
  CLEAN_VIEW,
  SEND_EMAIL_SUPPLIER,
  SEND_EMAIL_SUPPLIER_SUCCESS,
  SEND_EMAIL_SUPPLIER_FAIL,
  DELETE_FILE_UPLOAD,
  DELETE_FILE_UPLOAD_SUCCESS,
  DELETE_FILE_UPLOAD_FAIL,
} from "./actionTypes"

export const getFilesByArea = filter => {
  return {
    type: GET_FILE_BY_AREA,
    payload: { filter },
  }
}
export const getFilesByAreaSuccess = filesLs => ({
  type: GET_FILE_BY_AREA_SUCCESS,
  payload: filesLs,
})

export const getFilesByAreaFail = error => ({
  type: GET_FILE_BY_AREA_FAIL,
  payload: error,
})

export const fileToUpload = file => {
  return {
    type: UPLOAD_FILE,
    payload: { file },
  }
}
export const fileToUploadSuccess = file => ({
  type: UPLOAD_FILE_SUCCESS,
  payload: file,
})

export const fileToUploadFail = error => ({
  type: UPLOAD_FILE_FAIL,
  payload: error,
})
export const downloadFile = path => ({
  type: DOWNLOAD_FILE,
  payload: path,
})

export const downloadFileSuccess = file => ({
  type: DOWNLOAD_FILE_SUCCESS,
  payload: file,
})

export const downloadFileFail = error => ({
  type: DOWNLOAD_FILE_FAIL,
  payload: error,
})
export const cleanView = () => ({
  type: CLEAN_VIEW,
  payload: {},
})
export const sendEmail = body => ({
  type: SEND_EMAIL_SUPPLIER,
  payload: body,
})

export const sendEmailSuccess = body => ({
  type: SEND_EMAIL_SUPPLIER_SUCCESS,
  payload: body,
})

export const sendEmailFail = error => ({
  type: SEND_EMAIL_SUPPLIER_FAIL,
  payload: error,
})

export const deleteFiles = body => ({
  type: DELETE_FILE_UPLOAD,
  payload: body,
})

export const deleteFilesSuccess = body => ({
  type: DELETE_FILE_UPLOAD_SUCCESS,
  payload: body,
})

export const deleteFilesFail = error => ({
  type: DELETE_FILE_UPLOAD_FAIL,
  payload: error,
})
